import type { ReactNode } from 'react';
import { Button } from '@terra/ui-design-system';
import { HStack } from '@terra/ui-styled-system';

type LauncherRowButtonProps = {
  ariaLabel: string;
  onClick: () => void;
  children: ReactNode;
};

export function LauncherRowButton({
  ariaLabel,
  onClick,
  children,
}: LauncherRowButtonProps) {
  return (
    <Button
      variant="ghost"
      size="sm"
      w="full"
      minW="0"
      h="auto"
      px="3"
      py="2.5"
      borderRadius="md"
      justifyContent="flex-start"
      textAlign="start"
      bg="transparent"
      _hover={{ bg: 'bg.muted' }}
      aria-label={ariaLabel}
      onClick={onClick}
    >
      <HStack gap="3" w="full" minW="0" alignItems="center">
        {children}
      </HStack>
    </Button>
  );
}
